import React, { useEffect, useRef, useCallback, useState } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "components/Common/withRouter";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();

  // KULLANICI ROLLERİNİ BELİRLEME — HESAP_TURU alanına göre (varchar)
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const hesapTuru = authUser?.HESAP_TURU || "";

  const isAlici = hesapTuru === "Alıcı";
  const isSatici = hesapTuru === "Satıcı";
  const isAdmin = hesapTuru === "Admin";

  // ─── MENÜ ROZETLERİ ("görüldü" mantığı) ─────────────────────────────
  // Rozet artık "bekleyen kayıt sayısı" değil, bekleyenlerden o sayfa EN SON
  // açıldığından beri gelen YENİLERİ gösterir: sayfayı açınca sıfırlanır, yeni
  // kayıt gelince tekrar artar. Veritabanındaki durumlara dokunulmaz — işlenmemiş
  // kayıtlar sayfanın içinde "bekliyor" olarak görünmeye devam eder.
  // Görülen ID'ler tarayıcıda (localStorage) tutulur.
  // key → [entity, OData filtresi, rozetin sıfırlandığı sayfa]
  const KUYRUKLAR = {
    ilanOnay: ["ILANLAR", "AKTIF_DURUM eq 'Beklemede'", "/ilan-yonetimi"],
    magaza: ["MAGAZALAR", "DURUM eq 'Beklemede' or DURUM eq null", "/magaza-yonetimi"],
    // Admin onayı bekleyen değerleme İLANLARI (DEGERLEME_TALEPLERI kalıcı Beklemede kalıyor).
    degerleme: ["ILANLAR", "DEGERLEMEYE_ACIK_MI eq true and AKTIF_DURUM eq 'Beklemede'", "/degerleme-talepleri"],
    magazaSoru: ["MAGAZA_SORULAR", "DURUM eq 'BEKLIYOR' or DURUM eq null", "/magaza-sorulari"],
    geriBildirim: ["UYGULAMA_GERI_BILDIRIMLERI", "OKUNDU eq false", "/uygulama-geri-bildirimleri"],
    // Aksiyon bekleyen siparişler (CuzdanBekliyor alıcıyı bekliyor, admin işi değil).
    siparis: ["SIPARIS", "SIPARIS_DURUMU eq 'OdemeBekliyor' or SIPARIS_DURUMU eq 'Beklemede' or SIPARIS_DURUMU eq 'Onaylandı' or SIPARIS_DURUMU eq 'Onaylandi' or SIPARIS_DURUMU eq 'Ödeme Alindi - Kargolanacak'", "/siparis-yonetimi"],
    kurbanSiparis: ["KURBAN_HISSE_SIPARISLERI", "ODEME_DURUMU eq 'Beklemede'", "/kurban-siparis-yonetimi"],
    teslimat: ["SIPARIS_TESLIMATLARI", "TESLIMAT_DURUMU eq 'Beklemede' or TESLIMAT_DURUMU eq 'Siparis Alindi' or TESLIMAT_DURUMU eq null", "/teslimat-yonetimi"],
    // DURUM yazımları tutarsız → tolower().
    paraCekme: ["PARA_CEKME_TALEPLERI", "tolower(DURUM) eq 'beklemede'", "/para-cekme-talepleri"],
    iade: ["IADE_TALEPLERI", "tolower(DURUM) eq 'beklemede' or tolower(DURUM) eq 'inceleniyor' or tolower(DURUM) eq 'kargo bekleniyor'", "/iade-talepleri"],
    sikayet: ["ILAN_SIKAYETLERI", "tolower(DURUM) eq 'beklemede' or tolower(DURUM) eq 'yeni'", "/sikayet-yonetimi"],
    iletisim: ["ILETISIM_MESAJLARI", "tolower(DURUM) eq 'yeni'", "/iletisim-mesajlari"],
    // Uygulamadaki "Reklam için başvur" formundan gelen, henüz ele alınmamış başvurular.
    reklamBasvuru: ["REKLAM_BASVURULARI", "DURUM eq 'Yeni'", "/reklam-yonetimi"],
  };
  const GORULEN_ANAHTAR = "adminRozetGorulen";

  const [kuyruk, setKuyruk] = useState({}); // key → bekleyen ID listesi
  const [gorulen, setGorulen] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(GORULEN_ANAHTAR) || "{}");
    } catch {
      return {};
    }
  });
  const yeniSayisi = (key) => {
    const g = new Set(gorulen[key] || []);
    return (kuyruk[key] || []).filter((id) => !g.has(id)).length;
  };

  const bekleyenOnay = yeniSayisi("ilanOnay");
  const bekleyenMagaza = yeniSayisi("magaza");
  const bekleyenDegerleme = yeniSayisi("degerleme");
  const bekleyenMagazaSoru = yeniSayisi("magazaSoru");
  const okunmamisGeriBildirim = yeniSayisi("geriBildirim");
  const bekleyenSiparis = yeniSayisi("siparis");
  const bekleyenKurbanSiparis = yeniSayisi("kurbanSiparis");
  const bekleyenTeslimat = yeniSayisi("teslimat");
  const bekleyenParaCekme = yeniSayisi("paraCekme");
  const bekleyenIade = yeniSayisi("iade");
  const bekleyenSikayet = yeniSayisi("sikayet");
  const bekleyenIletisim = yeniSayisi("iletisim");
  const bekleyenReklamBasvuru = yeniSayisi("reklamBasvuru");
  const toplamYeni = Object.keys(KUYRUKLAR).reduce((t, k) => t + yeniSayisi(k), 0);

  // Tüm menü rozetlerini tek tıkla "okundu" say: her kuyruğun mevcut bekleyenleri
  // görüldü listesine yazılır → rozetler 0'a iner, yalnız bundan SONRA gelen
  // yeni kayıtlar sayılır. DB'deki durumlara dokunulmaz (kayıtlar sayfalarda
  // "bekliyor" olarak kalır).
  const tumunuOkunduSay = () => {
    const sonraki = { ...gorulen };
    Object.keys(KUYRUKLAR).forEach((key) => {
      if (kuyruk[key]) sonraki[key] = kuyruk[key];
    });
    setGorulen(sonraki);
    try {
      localStorage.setItem(GORULEN_ANAHTAR, JSON.stringify(sonraki));
    } catch {}
  };

  // Sıfırla: "görüldü" hafızasını temizler → rozetler yeniden TÜM bekleyenleri
  // gösterir (yanlışlıkla okundu sayılanları geri getirmek için).
  const rozetleriSifirla = () => {
    if (!window.confirm("Rozet hafızası sıfırlansın mı? Menüdeki sayılar tekrar tüm bekleyen kayıtları gösterecek.")) return;
    setGorulen({});
    try {
      localStorage.removeItem(GORULEN_ANAHTAR);
    } catch {}
  };

  // Bilgi amaçlı sayaçlar (görüldü mantığı yok): canlı/başlayacak mezat, Hizmet onay.
  const [canliMezat, setCanliMezat] = useState(0);
  const [bekleyenMezat, setBekleyenMezat] = useState(0);
  const [onayBekleyenMezat, setOnayBekleyenMezat] = useState(0);
  const [bekleyenHizmetOnay, setBekleyenHizmetOnay] = useState(0);

  useEffect(() => {
    if (!isAdmin) return;
    const token = localStorage.getItem("token") || authUser?.Token;
    if (!token) return;
    let cancelled = false;
    const headers = { Authorization: `Bearer ${token}` };
    const API = "https://harmanappapi.stechomeyazilim.info";

    const sayac = (url, setter) =>
      fetch(url, { headers })
        .then((r) => (r.ok ? r.text() : null))
        .then((t) => {
          const n = parseInt(t, 10);
          if (!cancelled && Number.isFinite(n)) setter(n);
        })
        .catch(() => {});

    const idListesi = (key, entity, filtre) =>
      fetch(`${API}/${entity}?$select=ID&$filter=${encodeURIComponent(filtre)}`, { headers })
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => {
          if (cancelled || !j || !Array.isArray(j.value)) return;
          const ids = j.value.map((x) => x.ID);
          setKuyruk((p) => ({ ...p, [key]: ids }));
        })
        .catch(() => {});

    const fetchAll = () => {
      Object.entries(KUYRUKLAR).forEach(([key, [entity, filtre]]) => idListesi(key, entity, filtre));
      // DURUM_ID: 1=Başlayacak, 2=Canlı.
      sayac(`${API}/MEZATLAR/$count?$filter=` + encodeURIComponent("DURUM_ID eq 2"), setCanliMezat);
      sayac(`${API}/MEZATLAR/$count?$filter=` + encodeURIComponent("DURUM_ID eq 1"), setBekleyenMezat);
      // 5 = Onay Bekliyor (yeni mezat admin onayına düşer).
      sayac(`${API}/MEZATLAR/$count?$filter=` + encodeURIComponent("DURUM_ID eq 5"), setOnayBekleyenMezat);
      // Hizmet'eGEL onaylı sağlayıcı başvuruları — custom uç {Bekleyen:n}.
      fetch(`${API}/api/Hizmet/OnayBasvurulari`, { headers })
        .then((r) => (r.ok ? r.json() : null))
        .then((j) => {
          if (!cancelled && j && Number.isFinite(j.Bekleyen)) setBekleyenHizmetOnay(j.Bekleyen);
        })
        .catch(() => {});
    };

    fetchAll();
    const id = setInterval(fetchAll, 60000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [isAdmin]); // eslint-disable-line react-hooks/exhaustive-deps

  // Rozetin sayfası açıkken o kuyruğun bekleyenleri "görüldü" sayılır (rozet sıfırlanır).
  const aktifYol = useLocation().pathname;
  useEffect(() => {
    const sayfaKeyleri = Object.entries(KUYRUKLAR)
      .filter(([, [, , sayfa]]) => sayfa === aktifYol)
      .map(([key]) => key);
    if (sayfaKeyleri.length === 0) return;
    setGorulen((onceki) => {
      const sonraki = { ...onceki };
      let degisti = false;
      sayfaKeyleri.forEach((key) => {
        const ids = kuyruk[key];
        if (!ids) return;
        const eski = new Set(onceki[key] || []);
        if (ids.some((x) => !eski.has(x)) || (onceki[key] || []).length !== ids.length) {
          sonraki[key] = ids;
          degisti = true;
        }
      });
      if (!degisti) return onceki;
      try {
        localStorage.setItem(GORULEN_ANAHTAR, JSON.stringify(sonraki));
      } catch {}
      return sonraki;
    });
  }, [aktifYol, kuyruk]); // eslint-disable-line react-hooks/exhaustive-deps

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active");
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show");
                parent5.childNodes[0].classList.remove("mm-active");
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">

            {/* ==================== GENEL ==================== */}
            <li className="menu-title d-flex align-items-center justify-content-between">
              <span>{props.t("Menü")}</span>
              {/* Dar sidebar'da "Okundu (123)" metni 3 satıra kırılıyordu: tek satırlık
                  hap düğmeye indirildi, açıklama title'da. */}
              {isAdmin && (
                <span className="d-flex align-items-center gap-1" style={{ textTransform: "none", letterSpacing: 0 }}>
                  {toplamYeni > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-success rounded-pill py-0 px-2 d-inline-flex align-items-center"
                      style={{ fontSize: 11, lineHeight: "18px", whiteSpace: "nowrap" }}
                      onClick={tumunuOkunduSay}
                      title={`Menüdeki ${toplamYeni} yeni kaydın tümünü okundu say`}
                    >
                      <i className="bx bx-check-double me-1" />
                      {toplamYeni > 99 ? "99+" : toplamYeni}
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-link text-muted p-0 border-0 d-inline-flex"
                    style={{ fontSize: 15 }}
                    onClick={rozetleriSifirla}
                    title="Rozet hafızasını sıfırla"
                  >
                    <i className="bx bx-reset" />
                  </button>
                </span>
              )}
            </li>

            <li>
              <Link to="/#">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Anasayfa")}</span>
              </Link>
            </li>

            {/* ==================== HIZLI ERİŞİM (ADMİN) ====================
                DeğereGel ve Mezatlar en çok kullanılan iki ekran; daha önce
                "İlan Yönetimi" / "Sipariş Yönetimi" alt menülerinin içinde
                gömülüydü. Üst seviyeye kısayol olarak alındı (alt menüdeki
                kayıtlar da yerinde duruyor). */}
            {isAdmin && (
              <>
                {/* Aktivasyon Analizi: "üye olan ilk ilanını ne zaman açıyor?"
                    Alt menüye gömülmedi — ilan sayısı bu ekrandaki huniden
                    yönetiliyor, günlük bakılması gereken bir rapor. */}
                <li>
                  <Link to="/aktivasyon-analizi">
                    <i className="bx bx-trending-up"></i>
                    <span>{props.t("Aktivasyon Analizi")}</span>
                  </Link>
                </li>

                {/* Etkileşim Raporu: mağaza profili / kategori açılışı ve satıcıyı
                    arama-WhatsApp-mesaj sayaçları (api/Etkilesim/Ozet). */}
                <li>
                  <Link to="/etkilesim-raporu">
                    <i className="bx bx-mouse"></i>
                    <span>{props.t("Etkileşim Raporu")}</span>
                  </Link>
                </li>

                {/* Oturum Raporu: sisteme giren/çıkan cihaz-kullanıcı sayısı (api/Oturum/Rapor). */}
                <li>
                  <Link to="/oturum-raporu">
                    <i className="bx bx-log-in-circle"></i>
                    <span>{props.t("Oturum Raporu")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/degerleme-talepleri">
                    <i className="bx bx-line-chart"></i>
                    <span>{props.t("DeğereGel")}</span>
                    {bekleyenDegerleme > 0 && (
                      <Badge color="warning" pill className="ms-2">
                        {bekleyenDegerleme}
                      </Badge>
                    )}
                  </Link>
                </li>

                <li>
                  <Link to="/hizmet-onay-basvurulari">
                    <i className="bx bx-shield-quarter"></i>
                    <span>{props.t("Hizmet'eGEL Onayları")}</span>
                    {bekleyenHizmetOnay > 0 && (
                      <Badge color="warning" pill className="ms-2">
                        {bekleyenHizmetOnay}
                      </Badge>
                    )}
                  </Link>
                </li>

                <li>
                  <Link to="/mezat-yonetimi">
                    {/* boxicons'ta bx-gavel yok; canlı yayın çağrışımı için broadcast. */}
                    <i className="bx bx-broadcast"></i>
                    <span>{props.t("Mezatlar")}</span>
                    {onayBekleyenMezat > 0 && (
                      <Badge
                        color="warning"
                        pill
                        className="ms-2"
                        title={`${onayBekleyenMezat} mezat onayınızı bekliyor`}
                      >
                        Onay {onayBekleyenMezat}
                      </Badge>
                    )}
                    {canliMezat > 0 ? (
                      <Badge
                        color="danger"
                        pill
                        className="ms-2"
                        title={`${canliMezat} mezat şu anda canlı yayında`}
                      >
                        ● CANLI {canliMezat}
                      </Badge>
                    ) : bekleyenMezat > 0 ? (
                      <Badge
                        color="secondary"
                        pill
                        className="ms-2"
                        title={`${bekleyenMezat} mezat başlamayı bekliyor`}
                      >
                        {bekleyenMezat}
                      </Badge>
                    ) : null}
                  </Link>
                </li>

                {/* İlan Yönetimi ve Kullanıcılar en çok kullanılan iki menü;
                    DeğereGel/Mezatlar kısayollarının hemen altına alındı.
                    Yönetim bölümündeki eski konumlarından TAŞINDILAR (kopya
                    değil) — aynı menü iki yerde görünüp karışıklık yaratmasın. */}
                {/* İlan & Ürün Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-package"></i>
                    <span>{props.t("İlan Yönetimi")}</span>
                    {(bekleyenOnay + bekleyenMagaza + bekleyenMagazaSoru + okunmamisGeriBildirim) > 0 && (
                      <Badge color="warning" pill className="ms-2">
                        {bekleyenOnay + bekleyenMagaza + bekleyenMagazaSoru + okunmamisGeriBildirim}
                      </Badge>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/ilan-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Tüm İlanlar")}</span>
                        {bekleyenOnay > 0 && (
                          <Badge color="warning" pill>
                            {bekleyenOnay}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/kategori-yonetimi">{props.t("Kategoriler")}</Link>
                    </li>
                    <li>
                      <Link to="/kategori-ozellik-yonetimi">{props.t("Kategori Özellikleri")}</Link>
                    </li>
                    <li>
                      <Link to="/magaza-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Mağazalar")}</span>
                        {bekleyenMagaza > 0 && (
                          <Badge color="warning" pill>
                            {bekleyenMagaza}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/sertifika-tanimlari">{props.t("Sertifika Tanımları")}</Link>
                    </li>
                    <li>
                      <Link to="/kullanici-sertifikalari">{props.t("Kullanıcı Sertifikaları")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-degerlemeleri">{props.t("İlan Değerlendirmeleri")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-teklifleri">{props.t("İlan Teklifleri")}</Link>
                    </li>
                    <li>
                      <Link to="/degerleme-talepleri">{props.t("Değerlendirme Talepleri")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-fiyat-log">{props.t("İlan Fiyat Logları")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-goruntulenme-log">{props.t("İlan Görüntüleme Logları")}</Link>
                    </li>
                    <li>
                      <Link to="/isletme-hizmetleri">{props.t("İşletme Hizmetleri")}</Link>
                    </li>
                    <li>
                      <Link to="/hizmet-onay-basvurulari">{props.t("Onaylı Sağlayıcı Başvuruları")}</Link>
                    </li>
                    <li>
                      <Link to="/hizmet-talebi-gir">{props.t("Hizmet Talebi Gir")}</Link>
                    </li>
                    <li>
                      <Link to="/magaza-sorulari" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Mağaza Soruları")}</span>
                        {bekleyenMagazaSoru > 0 && (
                          <Badge color="info" pill>
                            {bekleyenMagazaSoru}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/uygulama-geri-bildirimleri" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Uygulama Deneyimleri")}</span>
                        {okunmamisGeriBildirim > 0 && (
                          <Badge color="info" pill>
                            {okunmamisGeriBildirim}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/magaza-takipcileri">{props.t("Mağaza Takipçileri")}</Link>
                    </li>
                    <li>
                      <Link to="/magaza-favorileri">{props.t("Mağaza Favorileri")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-begenileri">{props.t("İlan Beğenileri")}</Link>
                    </li>
                    <li>
                      <Link to="/ilan-fiyat-alarmlari">{props.t("İlan Fiyat Alarmları")}</Link>
                    </li>
                    <li>
                      <Link to="/kayitli-aramalar">{props.t("Kayıtlı Aramalar")}</Link>
                    </li>
                    <li>
                      <Link to="/kategori-abonelikleri">{props.t("Kategori Abonelikleri")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Kullanıcı Yönetimi — üst rozet, alt menüdeki rozetlerin
                    toplamı (İlan Yönetimi ile aynı kural): menü kapalıyken de
                    bekleyen iş görünsün. */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bxs-user-detail"></i>
                    <span>{props.t("Kullanıcılar")}</span>
                    {bekleyenSikayet > 0 && (
                      <Badge color="danger" pill className="ms-2">
                        {bekleyenSikayet}
                      </Badge>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/contacts-list">{props.t("Kullanıcı Listesi")}</Link>
                    </li>
                    <li>
                      <Link to="/kullanici-haklari">{props.t("Kullanıcı Hakları (Eski)")}</Link>
                    </li>
                    <li>
                      <Link to="/kullanici-kategori-haklari">{props.t("Kategori Bazlı Haklar")}</Link>
                    </li>
                    <li>
                      <Link to="/moderatorler">{props.t("Moderatörler")}</Link>
                    </li>
                    <li>
                      <Link to="/sikayet-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Şikayetler")}</span>
                        {bekleyenSikayet > 0 && (
                          <Badge color="danger" pill className="ms-2">{bekleyenSikayet}</Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/engel-listesi">{props.t("Engel Listesi")}</Link>
                    </li>
                    <li>
                      <Link to="/yorum-yonetimi">{props.t("Yorum Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/bildirim-loglari">{props.t("Bildirim Logları")}</Link>
                    </li>
                    <li>
                      <Link to="/uzmanlar">{props.t("Uzmanlar")}</Link>
                    </li>
                    <li>
                      <Link to="/uzman-degerlendirmeleri">{props.t("Uzman Değerlendirmeleri")}</Link>
                    </li>
                  </ul>
                </li>
              </>
            )}

            {/* ==================== HESAP ==================== */}
            <li className="menu-title">{props.t("Hesap")}</li>

            <li>
              <Link to="/hesabim">
                <i className="bx bx-user"></i>
                <span>{props.t("Hesabım")}</span>
              </Link>
            </li>

            {/* ==================== İLANLAR ==================== */}
            
            {/*    <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-store-alt"></i>
                <span>{props.t("İlanlar")}</span>
              </Link>
              <ul className="sub-menu">
                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/job-list">{props.t("İlan Listesi")}</Link>
                  </li>
                )}

                <li>
                  <Link to="/job-apply">
                    {isAlici ? props.t("Taleplerim") : props.t("Siparişler")}
                  </Link>
                </li>
              </ul>
            </li> */}
        

            {/* ==================== PROFİLİM ==================== */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-id-card"></i>
                <span>{props.t("Profilim")}</span>
              </Link>
              <ul className="sub-menu">

                <li>
                  <Link to="/ecommerce-orders">{props.t("Faturalarım")}</Link>
                </li>

                <li>
                  <Link to="/tasks-list">{props.t("Değerlendirmelerim")}</Link>
                </li>

                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/ecommerce-products">{props.t("Tekliflerim")}</Link>
                  </li>
                )}

                <li>
                  <Link to="/ecommerce-customers">{props.t("Faturalandırma Bilgileri")}</Link>
                </li>

                {/* Alıcı ve Admin mağaza başvurusu yapabilir, zaten satıcı olanlar için gerek yok */}
              {/**   {(isAlici || isAdmin) && (
                  <li>
                    <Link to="/candidate-list">{props.t("Mağaza Başvurusu")}</Link>
                  </li>
                )}

                {(isSatici || isAdmin) && (
                  <li>
                    <Link to="/ecommerce-add-product">{props.t("Yeni İlan Ver")}</Link>
                  </li>
                )}
*/}
              
              
              </ul>
            </li>

            {/* ==================== YÖNETİM (SADECE ADMİN) ==================== */}
            {isAdmin && (
              <>
                <li className="menu-title">{props.t("Yönetim")}</li>

                {/* İçerik Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-edit-alt"></i>
                    <span>{props.t("İçerik Yönetimi")}</span>
                    {bekleyenIletisim + bekleyenReklamBasvuru > 0 && (
                      <Badge color="info" pill className="ms-2">
                        {bekleyenIletisim + bekleyenReklamBasvuru}
                      </Badge>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/blog-yonetimi">{props.t("Blog Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/ciftci-bilgi-menuleri">{props.t("Çiftçi Bilgi Menüleri")}</Link>
                    </li>
                    {/* Bilgi'ye Gel haber akışı: kaynak (RSS) tanımları ve
                        job'ın çektiği haberlerin moderasyonu. */}
                    <li>
                      <Link to="/haber-kaynaklari">{props.t("Haber Kaynakları (RSS)")}</Link>
                    </li>
                    <li>
                      <Link to="/haber-yonetimi">{props.t("Haber Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/slider-yonetimi">{props.t("Slider Görselleri")}</Link>
                    </li>
                    {/* Uygulama reklam alanları + "Reklam için başvur" başvuruları */}
                    <li>
                      <Link to="/reklam-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Reklam Yönetimi")}</span>
                        {bekleyenReklamBasvuru > 0 && (
                          <Badge color="warning" pill className="ms-2">{bekleyenReklamBasvuru}</Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/iletisim-mesajlari" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("İletişim Mesajları")}</span>
                        {bekleyenIletisim > 0 && (
                          <Badge color="info" pill className="ms-2">{bekleyenIletisim}</Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/mesajlasmalar">{props.t("Kullanıcı Mesajlaşmaları")}</Link>
                    </li>
                    <li>
                      <Link to="/bildirim-gonder">{props.t("Bildirim Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/fcm-tokenlari">{props.t("Bildirim (FCM) Token'ları")}</Link>
                    </li>
                    <li>
                      <Link to="/sss-yonetimi">{props.t("SSS Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/sayfa-icerikleri">{props.t("Sayfa İçerikleri (Yasal)")}</Link>
                    </li>
                    <li>
                      <Link to="/kurumsal-bilgiler">{props.t("Kurumsal Bilgiler")}</Link>
                    </li>
                    <li>
                      <Link to="/hizmet-sektorleri">{props.t("Hizmet Sektörleri")}</Link>
                    </li>
                    <li>
                      <Link to="/bilgi-videolari">{props.t("Bilgi Videoları")}</Link>
                    </li>
                  </ul>
                </li>


                {/* Sipariş & Teslimat — üst rozet, alt menüdeki rozetlerin
                    toplamı (İlan Yönetimi ile aynı kural). */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-cart"></i>
                    <span>{props.t("Sipariş Yönetimi")}</span>
                    {(bekleyenIade + bekleyenSiparis + bekleyenKurbanSiparis + bekleyenTeslimat) > 0 && (
                      <Badge color="warning" pill className="ms-2">
                        {bekleyenIade + bekleyenSiparis + bekleyenKurbanSiparis + bekleyenTeslimat}
                      </Badge>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/siparis-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Tüm Siparişler")}</span>
                        {bekleyenSiparis > 0 && (
                          <Badge color="warning" pill>
                            {bekleyenSiparis}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/kurban-siparis-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Kurban Siparişleri")}</span>
                        {bekleyenKurbanSiparis > 0 && (
                          <Badge color="warning" pill>
                            {bekleyenKurbanSiparis}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/teslimat-yonetimi" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Teslimatlar")}</span>
                        {bekleyenTeslimat > 0 && (
                          <Badge color="warning" pill>
                            {bekleyenTeslimat}
                          </Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/iade-talepleri" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("İade Talepleri")}</span>
                        {bekleyenIade > 0 && (
                          <Badge color="warning" pill className="ms-2">{bekleyenIade}</Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/mezat-yonetimi">{props.t("Mezatlar")}</Link>
                    </li>
                    <li>
                      <Link to="/siparis-detaylari">{props.t("Sipariş Detayları")}</Link>
                    </li>
                    <li>
                      <Link to="/kurbanlik-hayvan-listesi">{props.t("Kurbanlık Hayvanlar")}</Link>
                    </li>
                    <li>
                      <Link to="/kurbanlik-hisse-fiyatlari">{props.t("Kurbanlık Hisse Fiyatları")}</Link>
                    </li>
                    <li>
                      <Link to="/mezat-teklifleri">{props.t("Mezat Teklifleri")}</Link>
                    </li>
                    <li>
                      <Link to="/sepetler">{props.t("Sepetler")}</Link>
                    </li>
                    <li>
                      <Link to="/satin-alma-gecmisi">{props.t("Uygulama İçi Satın Almalar")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Cüzdan Yönetimi */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-wallet"></i>
                    <span>{props.t("Cüzdan Yönetimi")}</span>
                    {bekleyenParaCekme > 0 && (
                      <Badge color="danger" pill className="ms-2">
                        {bekleyenParaCekme}
                      </Badge>
                    )}
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/crypto-wallet">{props.t("Sistem Finans")}</Link>
                    </li>
                    <li>
                      <Link to="/kullanici-cuzdanlari">{props.t("Kullanıcı Cüzdanları")}</Link>
                    </li>
                    <li>
                      <Link to="/cuzdan-hareketleri">{props.t("Cüzdan Hareketleri")}</Link>
                    </li>
                    <li>
                      <Link to="/para-cekme-talepleri" className="d-flex align-items-center justify-content-between">
                        <span>{props.t("Para Çekme Talepleri")}</span>
                        {bekleyenParaCekme > 0 && (
                          <Badge color="danger" pill className="ms-2">{bekleyenParaCekme}</Badge>
                        )}
                      </Link>
                    </li>
                    <li>
                      <Link to="/odeme-yonetimi">{props.t("Ödeme Yönetimi")}</Link>
                    </li>
                    <li>
                      <Link to="/odeme-loglari">{props.t("Ödeme Logları")}</Link>
                    </li>
                  </ul>
                </li>

                {/* Finans */}
                <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-credit-card"></i>
                    <span>{props.t("Finans")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/kullanici-banka-bilgileri">{props.t("Kullanıcı Banka Bilgileri")}</Link>
                    </li>
                    <li>
                      <Link to="/fatura-bilgileri">{props.t("Fatura Bilgileri")}</Link>
                    </li>
                    <li>
                      <Link to="/paketler">{props.t("Paketler")}</Link>
                    </li>
                    <li>
                      <Link to="/satin-alma-gecmisi">{props.t("Uygulama İçi Satın Almalar")}</Link>
                    </li>
                  </ul>
                </li>


                {/* Sistem */}
                <li>
                  <Link to="/sistem-ayarlari">
                    <i className="bx bx-cog"></i>
                    <span>{props.t("Sistem Ayarları")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/apps-filemanager">
                    <i className="bx bx-file"></i>
                    <span>{props.t("Dosya Yöneticisi")}</span>
                  </Link>
                </li>

              </>
            )}

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
